import { AnyAction } from '@reduxjs/toolkit'

import {
  ADD_SPACE_ADMIN_SUCCESS,
  FETCH_ORG_ADMINS_TO_ADD_SUCCESS,
  FETCH_SPACE_MEMBERS_SUCCESS,
  REMOVE_SPACE_ADMIN_SUCCESS
} from './actionTypes'

export type OrganizationSpaceEditPageState = {
  users?: any[]
  searchedUsers?: any[]
}

export const initialState: OrganizationSpaceEditPageState = {}

export default function organizationSpaceEditPageReducer(
  state = initialState,
  action: AnyAction
): OrganizationSpaceEditPageState {
  switch (action.type) {
    case FETCH_SPACE_MEMBERS_SUCCESS: {
      return setUsers(action.response)
    }
    case FETCH_ORG_ADMINS_TO_ADD_SUCCESS: {
      return { ...state, searchedUsers: action.response.resources.map(({ id }: { id: string }) => id) }
    }
    case REMOVE_SPACE_ADMIN_SUCCESS: {
      return removeSpaceAdmin(action.response)
    }
    case ADD_SPACE_ADMIN_SUCCESS: {
      return addSpaceAdmin(action.response)
    }
    default: {
      return state
    }
  }

  function setUsers(users: any[]) {
    if (users) {
      const SpaceMembers = users.map(user => user.id)
      return { ...state, users: SpaceMembers }
    }

    return { ...state, users: [] }
  }

  function removeSpaceAdmin(user: any) {
    const users = state.users?.filter(item => {
      return item !== user.id
    })
    return { ...state, users: users }
  }

  function addSpaceAdmin(user: any) {
    if (state.users) {
      return { ...state, users: [...state.users, user.id] }
    } else {
      return { ...state, users: [user.id] }
    }
  }
}
